import { Injectable } from "@angular/core";
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { Observable } from "rxjs";
import { tap } from "rxjs/operators";
import * as Sentry from "@sentry/angular";

@Injectable()
export class ForbiddenInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      tap({
        error: (err: any) => {
          if (err instanceof HttpErrorResponse && err.status === 403) {
            Sentry.addBreadcrumb({
              type: "http",
              level: "fatal",
              category: "http.forbidden_request",
              timestamp: new Date().getTime(),
              data: {
                url: err.url,
                method: req.method,
                status_code: 403
              }
            });

            Sentry.captureException(err);
          }
        }
      })
    );
  }
}
